module.exports = __webpack_public_path__ + "static/grundriss_gewerbe_mini-d97e44b7dbd3f7c20096c3f8f04dffe6.png";